import translationManager from '@/API/translationManager';
import React, { useContext, createContext, useEffect, useState } from 'react';
import { TO_TRANSLATE } from '../constants/toTranslate';
import { AuthContext } from '@/common/contexts/authContext';


export const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
	const { authUser } = useContext(AuthContext);

	const [translation, setTranslation] = useState(TO_TRANSLATE);

	const translate = async () => {
		const user = authUser;

		if (!user) {
			return;
		}

		const translations = Object();

		await Promise.all(
			Object.entries(translation).map(async ([key, value]) => {
				const word = await translationManager.getTranslation(value, user.id);
				translations[key] = word;
			}),
		);

		setTranslation(() => translations);
	};

	useEffect(() => {
		translate();
	}, [authUser]);

	return (
		<TranslationContext.Provider value={{ translation, translate }}>
			{children}
		</TranslationContext.Provider>
	);
};
